var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateAdmins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20005_27238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36615 17.6837C7.69168 17.7435 6.04411 17.2601 4.66714 16.3049C3.29017 15.3497 2.25692 13.9735 1.72021 12.3797C1.18351 10.786 1.17185 9.05938 1.68696 7.45529C2.20207 5.85119 3.2166 4.4548 4.58049 3.47265C5.94438 2.4905 7.58519 1.97475 9.26025 2.00168C10.9353 2.02861 12.5557 2.59679 13.8816 3.62218M13.8816 3.62218L13.4725 1.53236M13.8816 3.62218L11.9217 4.44233",
    stroke: "#021472",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.10309,
    cy: 9.45271,
    rx: 2.4527,
    ry: 2.45271,
    stroke: "#021472",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0177 13.8933H7.63277C6.07487 13.8933 5.0002 16 6 17",
    stroke: "#021472",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5693 12.77L16.8155 13.8336M11.4154 16.3155L11 17.7338L12.6616 17.3792L17.4743 13.2713C17.63 13.1383 17.7175 12.958 17.7175 12.77C17.7175 12.5819 17.63 12.4016 17.4743 12.2686L17.4028 12.2076C17.247 12.0747 17.0358 12 16.8155 12C16.5952 12 16.3839 12.0747 16.2281 12.2076L11.4154 16.3155Z",
    stroke: "#021472",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20005_27238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateAdmins);
export default __webpack_public_path__ + "static/media/updateAdmins.a04d3a198fc2d1ab8f383cf70fda7c21.svg";
export { ForwardRef as ReactComponent };